import Api from '../api';
import {TENANT_OFFER_URL} from '../lib/constant';

// Plain promise call (no store): the org details Welcome offer block owns its
// state. Resolves to {success, offer} (protojson, lowerCamelCase).
export const updateTenantOffer = (tenantId, {enabled, extendDays = 0}) =>
  Api.put(TENANT_OFFER_URL.replace('{tenantId}', encodeURIComponent(tenantId)), {enabled, extendDays})
    .then(({data}) => data);
